// Bangladesh flag rendered as inline SVG (green field + red disc)
export const BdFlag = ({ size = 22, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    className={`rounded-full overflow-hidden ${className}`}
    aria-label="Bangladesh"
  >
    <rect width="22" height="22" rx="11" fill="#006a4e" />
    <circle cx="9.5" cy="11" r="5" fill="#f42a41" />
  </svg>
);
